exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".case-attorneys table tbody tr:last-child td{border-bottom:0}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/case/attorneys/CaseAttorneys.less
 ** module id = 1073
 ** module chunks = 0
 **/